import { render } from "./DelosProductCard.vue?vue&type=template&id=78387de4&scoped=true"
import script from "./DelosProductCard.vue?vue&type=script&lang=ts"
export * from "./DelosProductCard.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-78387de4"

export default script